"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var InputGroup = _styledComponents["default"].div.withConfig({
  displayName: "input-group__InputGroup",
  componentId: "c44rbl-0"
})(["position:relative;width:100%;", ""], function (props) {
  return !props.noMargins && "margin: 0 0 15px 0;";
});

var _default = InputGroup;
exports["default"] = _default;